import appAxios from "../services/axios";

export const getPhotoManifest = async () => {
  const resp = await appAxios.get("/wedding-images/gallery/manifest.json");
  return resp.data;
};

export const createRsvp = async (rsvp) => {
  const resp = await appAxios.post("/api/wedding/rsvp", rsvp);
  return resp.data;
};

export const getRsvp = async (token) => {
  const resp = await appAxios.get(
    `/api/wedding/rsvp/${encodeURIComponent(token)}`,
  );
  return resp.data;
};

export const updateRsvp = async (token, rsvp) => {
  const resp = await appAxios.put(
    `/api/wedding/rsvp/${encodeURIComponent(token)}`,
    rsvp,
  );
  return resp.data;
};

export const getAdminRsvps = async () => {
  const resp = await appAxios.get("/api/wedding/admin/rsvps");
  return resp.data;
};

export const getAdminStatus = async () => {
  const resp = await appAxios.get("/api/wedding/admin/status");
  return resp.data;
};

export const addStatusItem = async (item) => {
  const resp = await appAxios.post("/api/wedding/admin/status/items", item);
  return resp.data;
};

export const setStatusItemState = async (id, state) => {
  const resp = await appAxios.patch(`/api/wedding/admin/status/items/${id}`, {
    state,
  });
  return resp.data;
};

export const removeStatusItem = async (id) => {
  await appAxios.delete(`/api/wedding/admin/status/items/${id}`);
};

export const getThree = async () => {
  const resp = await appAxios.get("/api/wedding/three");
  return resp.data;
};
